import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import type { PropsWithChildren } from 'react';

const theme = createTheme({
  palette: {
    primary: { main: '#12617d', dark: '#123047', contrastText: '#fff' },
    secondary: { main: '#ce6a3a' },
    // Darker than the MUI defaults so white text on a filled chip meets WCAG AA (4.5:1).
    info: { main: '#0277bd' },
    warning: { main: '#c2410c' },
    background: { default: '#f4f7f9', paper: '#fff' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
    h1: { fontSize: '2rem', fontWeight: 750, letterSpacing: '-0.025em' },
    h2: { fontSize: '1.35rem', fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 650 },
  },
  components: {
    MuiButtonBase: { defaultProps: { disableRipple: true } },
    // Unselected toggles default to action.active, which falls just under AA on the page ground.
    MuiToggleButton: {
      styleOverrides: { root: ({ theme }) => ({ color: theme.palette.text.secondary }) },
    },
    MuiCard: { styleOverrides: { root: { boxShadow: '0 8px 28px rgba(18,48,71,.08)' } } },
  },
});

export function AppThemeProvider({ children }: PropsWithChildren): React.JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
